export default __webpack_public_path__ + "static/media/addFileIconDisabled.c1b76aeb.svg";